import css from 'styled-jsx/css';

const styles = css.global`#canais-atendimento-golpes {
    background: #DEEDF2;
    padding: 24px 0 56px;
    margin-bottom: 32px;
}

#canais-atendimento-golpes .is-desk {
    display: none;
}

#canais-atendimento-golpes .content-golpes-gray-title {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
    margin: 0;
}

#canais-atendimento-golpes .content-golpes-gray-paragrafo {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    line-height: 28px;
    max-width: 324px;
}

#canais-atendimento-golpes .custom-carousel .embla__container {
    justify-content: space-around;
}

#canais-atendimento-golpes .content-golpes-gray {
    display: flex;
    padding: 48px 16px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    border-radius: 4px;
    background: #444;
}

#canais-atendimento-golpes .content-golpes-slider {
    overflow: hidden;
    margin-top: 54px;
}

#canais-atendimento-golpes .home-pagination {
    margin-top: 40px;
}

#canais-atendimento-golpes .golpe-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin: 24px auto 0;
}

#canais-atendimento-golpes .golpe-img {
    margin: 0 auto;
    display: block;
    width: 100%;
}

#canais-atendimento-golpes .canais-slide {
    margin-right: 24px;
    max-width: 220px;
}

@media(min-width: 992px) {
    #canais-atendimento-golpes .is-desk {
        display: block;
    }

    #canais-atendimento-golpes .is-mob {
        display: none;
    }

    #canais-atendimento-golpes {
        padding: 64px 0 80px;
        margin-bottom: 0;
        z-index: 5;
        position: relative;
    }

    #canais-atendimento-golpes .content-golpes-gray {
        flex-direction: row;
        justify-content: space-around;
    }

    #canais-atendimento-golpes .content-golpes-gray-paragrafo {
        max-width: 600px;
    }

    #canais-atendimento-golpes .golpe-img {
        width: 294px;
        height: 272.618px;
    }

    #canais-atendimento-golpes .content-golpes {
        margin-top: 72px;
        display: flex;
        gap: 40px;
        justify-content: center;
    }

    #canais-atendimento-golpes .golpe-paragrafo {
        max-width: 294px;
    }
}`;

export default styles;